import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Title } from "react-head";
import ScrollToHeaderTitle from "misc/ScrollToHeaderTitle";
import DomainAnalyticsTable from "./domains/DomainAnalyticsTable";
import { useAnalyticsFilters, useDomainData } from "providers/AnalyticsProvider";

const DomainAnalyticsPage = () => {
  const { dateRange } = useAnalyticsFilters();
  const { goToDomainPage } = useDomainData();

  // goToDomainPage changes whenever filters or dates do, so this reloads page 1 on any change
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      goToDomainPage(1);
    }
  }, [dateRange, goToDomainPage]);

  return (
    <>
      <ScrollToHeaderTitle />
      <div className="px-2 md:px-8 dark:md:px-6">
        <Title>ScraperAPI | Domain breakdown</Title>
        <div className="text-2xl font-semibold py-6">Domain breakdown</div>
        <DomainAnalyticsTable mode="full" />
      </div>
      <Outlet />
    </>
  );
};

export default DomainAnalyticsPage;
